/* eslint-disable react/jsx-props-no-spreading */
import { CanvasAnimatedTile } from 'themes/canvas/components/CanvasAnimatedTile';
import { CanvasFooterReviews } from 'themes/canvas/components/FooterReviews/CanvasFooterReviews';
import { Marquee } from 'themes/canvas/components/Marquee/Marquee';

import { Heading } from 'components/Heading';
import Spinner from 'components/Spinner';

import { useHomePage } from 'hooks/page/home/useHomePage';
import { usePortfolioPage } from 'hooks/page/portfolio/usePortfolioPage';

import { TService } from 'types/service';

import { CanvasPortfolioImage } from './CanvasPortfolioImage';

import s from './CanvasPortfolio.module.css';

export const CanvasPortfolio = () => {
  const { isLoading, images } = usePortfolioPage();
  const { services } = useHomePage();

  const items = services.map((service: TService) => service.name);

  return (
    <div className={s.portfolioPage}>
      <section className={s.root}>
        <CanvasAnimatedTile>
          <Heading as="h2" variant="large" className={s.pageTitle}>
            Our Portfolio
          </Heading>
        </CanvasAnimatedTile>
        <div className={s.portfolioColumnsContainer}>
          {images &&
            images.map((image) => (
              <CanvasPortfolioImage key={image.image.medium} {...image} />
            ))}
          <Spinner loading={isLoading} />
        </div>
      </section>
      <div className={s.marquee}>
        <Marquee items={items} />
      </div>
      <section>
        <CanvasFooterReviews />
      </section>
    </div>
  );
};
